const ImageBanner = ({ src }) => {
  return (
    <div className="component-container image-banner-container">
      <img src={src} className="image-banner" alt="banner" />
    </div>
  )
}

export default ImageBanner;